document.addEventListener('DOMContentLoaded', function() {
  // Testimonial Slider (only if testimonials exist on page)
  const dots = document.querySelectorAll('.dot');
  
  if (dots.length > 0) {
    // Simulated testimonials data
    const testimonials = [
      {
        quote: "Working with MSH really changed the game when we were starting our new business",
        person: "PERSON NAME"
      },
      {
        quote: "Martha's insights helped us scale sustainably while maintaining our company values",
        person: "JANE SMITH"
      },
      {
        quote: "The MSH Collective workshops transformed how we approach leadership in our organization",
        person: "JOHN JOHNSON"
      }
    ];

    // Set initial testimonial to the third one to match current state
    const setInitialTestimonial = () => {
      const quoteElement = document.querySelector('.quote p');
      const authorElement = document.querySelector('.testimonial-author h4');
      if (quoteElement && authorElement) {
        quoteElement.textContent = testimonials[2].quote;
        authorElement.textContent = testimonials[2].person;
        document.querySelectorAll('.dot').forEach((dot, index) => {
          dot.classList.remove('active');
          if (index === 2) dot.classList.add('active');
        });
      }
    };
    
    // Initialize with the third testimonial
    setInitialTestimonial();
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        // Update active dot
        const activeDot = document.querySelector('.dot.active');
        if (activeDot) activeDot.classList.remove('active');
        dot.classList.add('active');
        
        // Update testimonial content
        const quoteElement = document.querySelector('.quote p');
        const authorElement = document.querySelector('.testimonial-author h4');
        if (quoteElement && authorElement) {
          quoteElement.textContent = testimonials[index].quote;
          authorElement.textContent = testimonials[index].person;
        }
      });
    });
    
    // Auto-rotate testimonials every 7 seconds
    let currentTestimonial = 2; // Start with the third one
    setInterval(() => {
      currentTestimonial = (currentTestimonial + 1) % testimonials.length;
      if (dots[currentTestimonial]) {
        dots[currentTestimonial].click();
      }
    }, 7000);
  }
  
  // Digest Navigation Shuffle Functionality
  const digestNavPrev = document.querySelector('.digest-nav-btn[aria-label="Previous"]');
  const digestNavNext = document.querySelector('.digest-nav-btn[aria-label="Next"]');
  const digestGrid = document.querySelector('.digest-grid');
  
  if (digestNavPrev && digestNavNext && digestGrid) {
    // Store original articles data
    const originalArticles = [
      {
        image: 'images/podcast_1.png',
        title: 'Scaling is not the holy grail of entrepreneurship',
        type: 'PODCAST'
      },
      {
        image: 'images/private_equity_money.png',
        title: 'Know what you\'re doing when you take private equity money',
        type: 'ARTICLE'
      },
      {
        image: 'images/Scaling.png',
        title: 'Defining the soul of your brand before you sell it away',
        type: 'PODCAST'
      },
      {
        image: 'images/dishthetea.png',
        title: '"Dish the Tea" Session',
        type: 'INTERVIEW'
      }
    ];
    
    // Function to shuffle array
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };
    
    // Function to update digest tiles
    const updateDigestTiles = (articles) => {
      const digestItems = document.querySelectorAll('.digest-item');
      
      articles.forEach((article, index) => {
        if (digestItems[index]) {
          const img = digestItems[index].querySelector('img');
          const title = digestItems[index].querySelector('h4');
          const type = digestItems[index].querySelector('.content-type');
          
          if (img) img.src = article.image;
          if (title) title.textContent = article.title;
          if (type) type.textContent = article.type;
        }
      });
    };
    
    // Function to animate tile refresh
    const refreshTiles = () => {
      const digestItems = document.querySelectorAll('.digest-item');
      
      // Fade out
      digestItems.forEach(item => {
        item.style.opacity = '0.3';
      });
      
      // Shuffle and update content
      setTimeout(() => {
        const shuffledArticles = shuffleArray(originalArticles);
        updateDigestTiles(shuffledArticles);
        
        // Fade back in
        digestItems.forEach(item => {
          item.style.opacity = '1';
        });
      }, 200);
    };
    
    // Add transition styles to digest items
    const digestItems = document.querySelectorAll('.digest-item');
    digestItems.forEach(item => {
      item.style.transition = 'opacity 0.3s ease';
    });
    
    // Add event listeners to navigation buttons
    digestNavPrev.addEventListener('click', refreshTiles);
    digestNavNext.addEventListener('click', refreshTiles);
  }

  // Digest Articles Swap Functionality
  const scrollWrapper = document.querySelector('.digest-scroll-wrapper');
  const scrollPrevBtn = document.querySelector('.scroll-prev');
  const scrollNextBtn = document.querySelector('.scroll-next');
  const digestItems = document.querySelectorAll('.digest-item');
  const moreLink = document.querySelector('.more-link a');
  
  if (scrollWrapper && scrollPrevBtn && scrollNextBtn && digestItems.length > 0) {
    let currentPage = 0;
    let isTransitioning = false;
    const itemsPerPage = 4; // Show 4 articles at a time (2x2 grid)
    const totalPages = Math.ceil(digestItems.length / itemsPerPage);
    
    // Create pages of articles
    const pages = [];
    for (let i = 0; i < totalPages; i++) {
      const pageItems = Array.from(digestItems).slice(i * itemsPerPage, (i + 1) * itemsPerPage);
      pages.push(pageItems);
    }
    
    // Function to update button states
    const updateButtonStates = () => {
      // Show/hide previous button
      if (currentPage === 0) {
        scrollPrevBtn.style.opacity = '0.3';
        scrollPrevBtn.disabled = true;
      } else {
        scrollPrevBtn.style.opacity = '0.6';
        scrollPrevBtn.disabled = false;
      }
      
      // Show/hide next button
      if (currentPage >= totalPages - 1) {
        scrollNextBtn.style.opacity = '0.3';
        scrollNextBtn.disabled = true;
      } else {
        scrollNextBtn.style.opacity = '0.6';
        scrollNextBtn.disabled = false;
      }
    };
    
    // Function to show specific page with fade transition
    const showPage = (pageIndex) => {
      if (isTransitioning) return;
      isTransitioning = true;
      
      // Fade out current articles all at once
      const currentItems = pages[currentPage] || [];
      currentItems.forEach((item) => {
        item.classList.add('hidden');
      });
      
      // After fade out, show new articles all at once
      setTimeout(() => {
        // Show articles for new page
        const newItems = pages[pageIndex] || [];
        newItems.forEach((item) => {
          item.classList.remove('hidden');
          item.classList.add('fade-in');
          
          // Remove fade-in class after animation
          setTimeout(() => {
            item.classList.remove('fade-in');
          }, 500);
        });
        
        currentPage = pageIndex;
        updateButtonStates();
        
        setTimeout(() => {
          isTransitioning = false;
        }, 600);
      }, 300);
    };
    
    // Initialize - show first page and hide all others
    digestItems.forEach((item, index) => {
      if (index < itemsPerPage) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
    
    // Initialize button states
    updateButtonStates();
    
    // Hide both buttons if only one page
    if (totalPages <= 1) {
      scrollPrevBtn.style.display = 'none';
      scrollNextBtn.style.display = 'none';
    }
    
    // Previous button functionality
    scrollPrevBtn.addEventListener('click', () => {
      if (currentPage > 0 && !isTransitioning) {
        showPage(currentPage - 1);
      }
    });
    
    // Next button functionality
    scrollNextBtn.addEventListener('click', () => {
      if (currentPage < totalPages - 1 && !isTransitioning) {
        showPage(currentPage + 1);
      }
    });
    
    // More link functionality - navigate to digest page
    // No JavaScript needed - let it navigate naturally to digest.html
  }
  
  // Smooth scrolling for navigation links
  document.querySelectorAll('.nav a').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });
  
  // Podcast Episodes Slider (horizontal with infinite loop)
  const sliderTrack = document.querySelector('.slider-track');
  const episodeCards = document.querySelectorAll('.episode-card');
  
  if (sliderTrack && episodeCards.length > 0) {
    let currentSlide = 0;
    let isTransitioning = false;
    
    // Clone cards for infinite loop effect
    const cloneCards = () => {
      episodeCards.forEach(card => {
        const clone = card.cloneNode(true);
        sliderTrack.appendChild(clone);
      });
    };
    
    // Add clones for seamless looping
    cloneCards();
    
    // Get all cards including clones
    const allCards = document.querySelectorAll('.episode-card');
    const totalCards = episodeCards.length;
    
    // Function to move to specific slide
    const moveToSlide = (slideIndex, instant = false) => {
      if (isTransitioning) return;
      currentSlide = slideIndex;
      // Calculate transform value based on card width + gap
      const cardWidth = 60; // 60rem
      const gap = 2; // 2rem gap
      const translateX = currentSlide * (cardWidth + gap);
      
      if (instant) {
        sliderTrack.style.transition = 'none';
        sliderTrack.style.transform = `translateX(-${translateX}rem)`;
        // Force reflow
        sliderTrack.offsetHeight;
        sliderTrack.style.transition = 'transform 0.5s ease';
      } else {
        sliderTrack.style.transform = `translateX(-${translateX}rem)`;
      }
    };
    
    // Function to handle infinite loop - always forward direction
    const handleInfiniteLoop = () => {
      if (currentSlide >= totalCards) {
        isTransitioning = true;
        setTimeout(() => {
          currentSlide = 0;
          moveToSlide(0, true);
          setTimeout(() => {
            isTransitioning = false;
          }, 50);
        }, 500);
      } else if (currentSlide < 0) {
        // For backward navigation, still loop to end
        isTransitioning = true;
        setTimeout(() => {
          currentSlide = totalCards - 1;
          moveToSlide(totalCards - 1, true);
          setTimeout(() => {
          isTransitioning = false;
          }, 50);
        }, 500);
      }
    };
    
    // Initialize
    moveToSlide(0);
    
    // Touch/swipe functionality for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    let isSwiping = false;
    const minSwipeDistance = 50; // Minimum distance for a swipe
    
    const sliderContainer = document.querySelector('.episodes-slider');
    if (sliderContainer) {
      // Touch events for mobile swipe
      sliderContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isSwiping = false;
      }, { passive: true });
      
      sliderContainer.addEventListener('touchmove', (e) => {
        if (!touchStartX) return;
        
        const touchCurrentX = e.touches[0].clientX;
        const touchCurrentY = e.touches[0].clientY;
        const deltaX = Math.abs(touchCurrentX - touchStartX);
        const deltaY = Math.abs(touchCurrentY - touchStartY);
        
        // If horizontal swipe is more significant than vertical, prevent scrolling
        if (deltaX > deltaY && deltaX > 10) {
          e.preventDefault();
          isSwiping = true;
        }
      }, { passive: false });
      
      sliderContainer.addEventListener('touchend', (e) => {
        if (!touchStartX || isTransitioning) return;
        
        touchEndX = e.changedTouches[0].clientX;
        touchEndY = e.changedTouches[0].clientY;
        
        const swipeDistanceX = touchStartX - touchEndX;
        const swipeDistanceY = Math.abs(touchStartY - touchEndY);
        
        // Only process horizontal swipes (ignore vertical scrolling)
        if (Math.abs(swipeDistanceX) > minSwipeDistance && Math.abs(swipeDistanceX) > swipeDistanceY) {
          if (swipeDistanceX > 0) {
            // Swiped left - go to next slide
            currentSlide++;
            moveToSlide(currentSlide);
            setTimeout(() => handleInfiniteLoop(), 50);
          } else {
            // Swiped right - go to previous slide
            currentSlide--;
            moveToSlide(currentSlide);
            setTimeout(() => handleInfiniteLoop(), 50);
          }
        }
        
        // Reset touch coordinates
        touchStartX = 0;
        touchEndX = 0;
        touchStartY = 0;
        touchEndY = 0;
        isSwiping = false;
      }, { passive: true });
    
      // Area-based navigation - left half goes back, right half goes forward (for desktop)
      sliderContainer.addEventListener('click', (e) => {
        if (isTransitioning || isSwiping) return;
        
        const containerRect = sliderContainer.getBoundingClientRect();
        const clickX = e.clientX - containerRect.left;
        const containerWidth = containerRect.width;
        const isLeftHalf = clickX < containerWidth / 2;
        
        if (isLeftHalf) {
          // Left half - go to previous slide
          currentSlide--;
          moveToSlide(currentSlide);
          setTimeout(() => handleInfiniteLoop(), 50);
        } else {
          // Right half - go to next slide
          currentSlide++;
          moveToSlide(currentSlide);
          setTimeout(() => handleInfiniteLoop(), 50);
        }
      });
    }
    
    // Auto-advance slider continuously in one direction
    setInterval(() => {
      if (!isTransitioning) {
        currentSlide++;
        moveToSlide(currentSlide);
        setTimeout(() => handleInfiniteLoop(), 50);
      }
    }, 4000); // Auto-advance every 4 seconds
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (isTransitioning) return;
      if (e.key === 'ArrowLeft') {
        currentSlide--;
        moveToSlide(currentSlide);
        setTimeout(() => handleInfiniteLoop(), 50);
      } else if (e.key === 'ArrowRight') {
        currentSlide++;
        moveToSlide(currentSlide);
        setTimeout(() => handleInfiniteLoop(), 50);
      }
    });
  }
  
  // Form submission handlers - DISABLED to prevent interference with newsletter forms
  // TODO: Re-enable only for specific forms that need custom handling
  /*
  const forms = document.querySelectorAll('form');
  
  forms.forEach(form => {
    // Skip ALL forms that have email inputs OR newsletter/podcast classes
    if (form.querySelector('input[type="email"]') || 
        form.classList.contains('newsletter-form') || 
        form.classList.contains('podcast-signup-form') ||
        form.getAttribute('action') && form.getAttribute('action').includes('customer')) {
      return; // Let these forms submit naturally
    }
    
    // Only handle other forms (like contact forms without email)
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      console.log('Custom form handler for non-email form');
      // Add custom handling here if needed
    });
  });
  */

  // CAPTCHA Overlay Functionality - DISABLED for modal form handler
  function initCaptchaOverlay() {
    console.log('CAPTCHA overlay DISABLED - using modal form handler instead');
    return; // Exit early to prevent conflicts with modal form handler
    
    // Prevent multiple overlays from being created
    if (document.querySelector('.captcha-overlay')) {
      console.log('CAPTCHA overlay already exists, skipping...');
      return;
    }
    
    // Store scroll position before CAPTCHA
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem('captchaScrollPosition', scrollPosition);
    
    // Check if we're on a CAPTCHA challenge page
    console.log('Checking for CAPTCHA page. URL:', window.location.href);
    console.log('Looking for CAPTCHA elements...');
    
    const isCaptchaUrl = window.location.href.includes('challenge') || 
                        window.location.href.includes('captcha') ||
                        window.location.href.includes('hcaptcha');
    const hasCaptchaContainer = document.querySelector('.shopify-challenge__container') ||
                               document.querySelector('.challenge-container') ||
                               document.querySelector('[class*="captcha"]') ||
                               document.querySelector('[class*="hcaptcha"]') ||
                               document.querySelector('iframe[src*="captcha"]');
    const hasAuthToken = document.querySelector('input[name="authenticity_token"]');
    const hasCaptchaForm = document.querySelector('form[action*="challenge"]') ||
                          document.querySelector('form') && document.body.textContent.includes('captcha');
    
    console.log('CAPTCHA detection:', {
      isCaptchaUrl,
      hasCaptchaContainer,
      hasAuthToken,
      hasCaptchaForm,
      bodyText: document.body.textContent.toLowerCase().includes('captcha') || 
                document.body.textContent.toLowerCase().includes('verification')
    });
    
    if (isCaptchaUrl || hasCaptchaContainer || (hasAuthToken && hasCaptchaForm)) {
      
      // Create overlay structure
      const overlay = document.createElement('div');
      overlay.className = 'captcha-overlay';
      
      const popup = document.createElement('div');
      popup.className = 'captcha-popup';
      
      // Add close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'captcha-close';
      closeBtn.innerHTML = '×';
      closeBtn.onclick = () => {
        // Restore scroll position and go back
        const scrollPos = sessionStorage.getItem('captchaScrollPosition') || sessionStorage.getItem('formScrollPosition') || 0;
        sessionStorage.removeItem('captchaScrollPosition');
        window.history.back();
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollPos));
          // Extra attempts to ensure scroll restoration
          setTimeout(() => window.scrollTo(0, parseInt(scrollPos)), 50);
          setTimeout(() => window.scrollTo(0, parseInt(scrollPos)), 100);
          setTimeout(() => window.scrollTo(0, parseInt(scrollPos)), 200);
        }, 50);
      };
      
      // Find the CAPTCHA content - look for the actual form and content
      const captchaForm = document.querySelector('form[action*="challenge"]') || 
                          document.querySelector('form[method="post"]');
      const captchaContainer = document.querySelector('.shopify-challenge__container') || 
                               document.querySelector('body > div') ||
                               document.body;
      
      if (captchaForm) {
        // Add title
        const title = document.createElement('h2');
        title.textContent = 'Security Verification';
        popup.appendChild(title);
        
        // Add close button
        popup.appendChild(closeBtn);
        
        // Save current scroll position before showing overlay
        const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.top = `-${currentScrollY}px`;
        
        // Hide the submit button from the form - we only want the CAPTCHA
        const submitButtons = captchaForm.querySelectorAll('button[type="submit"], input[type="submit"], .btn');
        submitButtons.forEach(btn => {
          if (!btn.textContent.includes('×')) { // Don't hide close button
            btn.style.display = 'none';
          }
        });
        
        // Move the actual form (don't clone, move it)
        popup.appendChild(captchaForm);
        overlay.appendChild(popup);
        
        // Hide original page content and show overlay
        document.body.classList.add('captcha-active');
        document.body.appendChild(overlay);
        
        // Hide everything else on the page
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach(child => {
          if (child !== overlay) {
            child.style.display = 'none';
          }
        });
        
        // Ensure CAPTCHA widget is properly initialized after moving to popup
        setTimeout(() => {
          // Look for hCaptcha widgets and reinitialize them
          const hcaptchaElements = popup.querySelectorAll('.h-captcha, [class*="hcaptcha"], [data-hcaptcha]');
          hcaptchaElements.forEach(element => {
            // Make sure the element is visible and properly sized
            element.style.display = 'block';
            element.style.margin = '20px auto';
            element.style.textAlign = 'center';
            
            // Trigger hCaptcha render if available
            if (window.hcaptcha && window.hcaptcha.render) {
              try {
                console.log('🔄 Re-rendering hCaptcha widget in popup');
                window.hcaptcha.render(element);
              } catch (e) {
                console.log('hCaptcha render failed:', e);
              }
            }
          });
          
          // Also check for any iframes that might contain CAPTCHA
          const captchaIframes = popup.querySelectorAll('iframe[src*="captcha"], iframe[src*="hcaptcha"]');
          captchaIframes.forEach(iframe => {
            iframe.style.display = 'block';
            iframe.style.margin = '20px auto';
            iframe.style.width = '100%';
            iframe.style.maxWidth = '400px';
            iframe.style.height = 'auto';
            iframe.style.minHeight = '120px';
          });
          
          // Ensure form elements are interactive
          const formElements = popup.querySelectorAll('input, button, select, textarea');
          formElements.forEach(element => {
            element.style.pointerEvents = 'auto';
            element.style.zIndex = '10001';
          });
          
          // Auto-submit form when CAPTCHA is completed
          if (window.hcaptcha) {
            window.hcaptcha.setCallback = function(token) {
              console.log('✅ CAPTCHA completed, auto-submitting form');
              if (captchaForm) {
                captchaForm.submit();
              }
            };
          }
          
          // Also listen for hCaptcha success event
          hcaptchaElements.forEach(element => {
            element.addEventListener('verified', () => {
              console.log('✅ CAPTCHA verified, auto-submitting form');
              setTimeout(() => {
                if (captchaForm) {
                  captchaForm.submit();
                }
              }, 500);
            });
          });
          
          console.log('✅ CAPTCHA popup initialized with', hcaptchaElements.length, 'hCaptcha widgets and', captchaIframes.length, 'iframes');
        }, 200);
        
        // The form will submit naturally and redirect
      } else {
        console.log('No CAPTCHA form found, falling back to page display');
      }
    }
  }
  
  // Initialize CAPTCHA overlay when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCaptchaOverlay);
  } else {
    initCaptchaOverlay();
  }
  
  // Track if we've already processed CAPTCHA to prevent loops
  let captchaProcessed = false;
  
  // Also check for CAPTCHA when page content changes (for dynamic loading)
  const observer = new MutationObserver((mutations) => {
    // Prevent infinite loops
    if (captchaProcessed || document.querySelector('.captcha-overlay')) {
      return;
    }
    
    let shouldCheckCaptcha = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Skip if this is our own overlay
            if (node.classList && node.classList.contains('captcha-overlay')) {
              return;
            }
            
            const nodeText = node.textContent || '';
            if (nodeText.toLowerCase().includes('captcha') || 
                nodeText.toLowerCase().includes('verification') ||
                node.querySelector && (
                  node.querySelector('[class*="captcha"]') ||
                  node.querySelector('[class*="hcaptcha"]') ||
                  node.querySelector('iframe[src*="captcha"]')
                )) {
              shouldCheckCaptcha = true;
            }
          }
        });
      }
    });
    
    if (shouldCheckCaptcha) {
      console.log('🔍 CAPTCHA content detected via mutation observer, checking...');
      captchaProcessed = true; // Prevent further processing
      setTimeout(() => {
        initCaptchaOverlay();
      }, 100);
    }
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Restore scroll position when returning from CAPTCHA
  window.addEventListener('pageshow', function(event) {
    const scrollPos = sessionStorage.getItem('captchaScrollPosition');
    if (scrollPos && !window.location.href.includes('challenge')) {
      sessionStorage.removeItem('captchaScrollPosition');
      window.scrollTo(0, parseInt(scrollPos));
    }
  });

  // Menu functionality is handled in header.liquid to avoid conflicts

  // Speaking Topics Carousel
  const topicSlides = document.querySelectorAll('.topic-slide');
  const topicTitles = document.querySelectorAll('.topics-main-title');
  let currentTopicIndex = 0;

  if (topicSlides.length > 0) {
    const showTopic = (index) => {
      topicSlides.forEach((slide, i) => {
        slide.style.opacity = '0';
        slide.classList.remove('active');
        if (i === index) {
          slide.style.opacity = '1';
          slide.classList.add('active');
        }
      });
    };

    const nextTopic = () => {
      currentTopicIndex = (currentTopicIndex + 1) % topicSlides.length;
      showTopic(currentTopicIndex);
    };

    // Make topic titles clickable
    topicTitles.forEach((title) => {
      title.addEventListener('click', nextTopic);
    });

    // Auto-rotate topics every 5 seconds
    setInterval(nextTopic, 5000);

    // Initial display
    showTopic(currentTopicIndex);
  }
}); 